<div class="bisual-table">
  <form class="card paginator" [formGroup]="filterForm">
    <button mat-flat-button color="accent" type="button" (click)="openRequestDialog()">
      <mat-icon>add</mat-icon>
      Solicitar formación
    </button>

    <mat-paginator
      [length]="length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      [pageIndex]="pageIndex"
      (page)="changePage($event)"
      style="margin-right: auto"
    ></mat-paginator>

    <mat-form-field>
      <input matInput type="text" formControlName="search" placeholder="Buscar..." />
      <button matSuffix mat-icon-button aria-label="Buscar" type="button">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
  </form>

  <div class="bisual-table-container">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let element">
          <span class="resource-name">{{ element.name }}</span>
          @if (element.is_active_enrollment) {
            <span class="active-enrollment-badge">Tu formación activa</span>
          }
          @if (element.has_completed_achievement) {
            <span class="completed-achievement-badge">Curso completado</span>
            @if (element.completed_ago_label) {
              <span class="completed-ago-label">{{ element.completed_ago_label }}</span>
            }
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="duration_in_hours">
        <th mat-header-cell *matHeaderCellDef>Duración (h)</th>
        <td mat-cell *matCellDef="let element">{{ element.duration_in_hours ?? '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="skills">
        <th mat-header-cell *matHeaderCellDef>Skills</th>
        <td mat-cell *matCellDef="let element">
          <span [matTooltip]="element.skills_label.length > 50 ? element.skills_label : null">
            {{ element.skills_label }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            @if (element.is_active_enrollment) {
              <button
                mat-menu-item
                [disabled]="!current_user() || completing_learning_resource_id() === element.id"
                (click)="completeActiveEnrollment(element)"
              >
                <mat-icon style="margin-right: 10px">check_circle</mat-icon>
                Completar formación
              </button>
            } @else if (!element.has_completed_achievement) {
              <button
                mat-menu-item
                [disabled]="!current_user() || activating_learning_resource_id() === element.id"
                (click)="openActivateDialog(element)"
              >
                <mat-icon style="margin-right: 10px">play_circle</mat-icon>
                Activar
              </button>
            }
            @if (element.url) {
              <button mat-menu-item (click)="openLearningResource(element)">
                <mat-icon style="margin-right: 10px">open_in_new</mat-icon>
                Ver formación
              </button>
            }
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
